import { Flex, Image } from '@chakra-ui/react';

import { useColorMode } from '@chakra-ui/react';
import { useCallback, useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { getLoginFormPagePath } from '../../App';
import Button from '../../components/button';
import CustomSelectBox from '../../components/custom-selectbox';
import Heading from '../../components/heading';
import Layout from '../../components/layout';
import { useSession } from '../../hooks/useSession';
import Logos from '../../images/logos';
import { TBookAbbrvs } from '../../types';
import { IBookSelectOption } from './select-root';

export interface SelectSportsbookProps {
    currentState: string;
    selectedBookOption?: IBookSelectOption;
    bookOptions: IBookSelectOption[];
    setSelectedBookOption: (bookOption: IBookSelectOption) => void;
}

export default function SelectSportsbook(props: SelectSportsbookProps) {
    const {
        currentState,
        selectedBookOption,
        bookOptions,
        setSelectedBookOption,
    } = props;
    const { push } = useHistory();
    const session = useSession();
    const { colorMode, toggleColorMode } = useColorMode();
    const [pageHeight, setPageHeight] = useState(window.innerHeight - 40);

    const goToTheLoginPage = useCallback(() => {
        push(
            getLoginFormPagePath(
                session?.cid!,
                selectedBookOption?.bookRegionId!
            )
        );
    }, [selectedBookOption]);

    useEffect(() => {
        if (
            session?.uiMode &&
            session?.uiMode != 'system' &&
            session?.uiMode != colorMode
        )
            toggleColorMode();
    }, []);

    //auto scroll to top of page
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    useEffect(() => {

        const handleResize = () => {
            setPageHeight(window.innerHeight); // Adjust the offset as needed
            };

            // Add an event listener to window resize
            window.addEventListener('resize', handleResize);

            // Clean up the event listener on component unmount
            return () => {
            window.removeEventListener('resize', handleResize);
            };

    }, []);

    return (
        <Layout
            colorMode={colorMode}
            alert={session?.user?.isSandbox ? 'SANDBOX MODE' : ''}
            buttons={
                <Button
                    onClick={goToTheLoginPage}
                    isDisabled={!selectedBookOption}
                    w="full"
                >
                    Continue
                </Button>
            }
            hasBackButton={session?.user?.backButton}
        >
            <Flex
                direction="column"
                align="center"
                gap="32px"
                w="full"
                textAlign="center"
            >
                {session?.logoUrl && (
                    <Image
                        maxH="80px"
                        maxW="200px"
                        src={session?.logoUrl || ''}
                        alt="Sharp Sports"
                    />
                )}
                <Heading mb="-8px">Select Sportsbook</Heading>
                <Flex
                    direction="column"
                    gap="24px"
                    w="full"
                    mb="200px"
                    style={{ overflowY: 'auto',maxHeight: session?.logoUrl ? `${pageHeight - 260}px` : `${pageHeight - 180}px`}}
                >
                    {bookOptions.map((bookOption) => (
                        <CustomSelectBox
                            key={bookOption.value}
                            label={bookOption.label}
                            logo={
                                Logos[colorMode][
                                    bookOption.value as TBookAbbrvs
                                ]
                            }
                            darkLogo={
                                Logos[colorMode][
                                    bookOption.value as TBookAbbrvs
                                ]
                            }
                            onChange={(isChecked) =>
                                isChecked && setSelectedBookOption(bookOption)
                            }
                            isChecked={
                                selectedBookOption?.value === bookOption.value
                            }
                            isDisabled={bookOption.isDisabled}
                            disabledText={bookOption.disabledText}
                            colorMode={colorMode}
                        />
                    ))}
                    <div>&nbsp;</div>
                    <div>&nbsp;</div>
                    <div>&nbsp;</div>
                    <div>&nbsp;</div>
                </Flex>
            </Flex>
        </Layout>
    );
}
